import { render, staticRenderFns } from "./TheVirtualPbx.vue?vue&type=template&id=3417916a&"
import script from "./TheVirtualPbx.vue?vue&type=script&lang=js&"
export * from "./TheVirtualPbx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports